// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".font-bold {\n  font-weight: bold;\n}\ntbody tr:last-child {\n  border-top: 1px solid #3c3cfa !important;\n}\n\n", ""]);
// Exports
module.exports = exports;
